import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-265" data-mp="3a1onk34aj8d0">
      <SiteHeader data-id="element-266" data-mp="3a4avi3v3fpvr" />
      <main className="flex-1" data-id="element-267" data-mp="3f1uaj5zm86or">
        <Outlet data-id="element-268" data-mp="3f2vwi5i66dl9" />
      </main>
      <SiteFooter data-id="element-269" data-mp="3ezgdwspaemf3" />
    </div>;
}